import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/development.env';

@Injectable({
	providedIn: 'root'
})

export class ServiceApi {

  base_url:any

  constructor(private http: HttpClient) {

    this.base_url = environment.base_url
  }


  getService() {

    return this.http.get(this.base_url+'/myalltel/services/') 
  }

  updateService(data) {

    return this.http.post(this.base_url+'/myalltel/services/update', data)
  }

  getVirtualReceptionServiceDetails(service_id) {
    return this.http.get(this.base_url+'/myalltel/services/'+service_id) 
  }

  getServiceDetails(service_id) {
    return this.http.get(this.base_url+'/myalltel/services/'+service_id) 
  }

  getVirtualReceptionistConfig(service_id) {

    return this.http.get(this.base_url+'/myalltel/config/virtualreceptionist/'+service_id) 
  }

  getTmcConfig(service_id) {

    return this.http.get(this.base_url+'/myalltel/config/tmc/'+service_id) 
  }
  getInspraConfig(service_id) {

    return this.http.get(this.base_url+'/myalltel/config/inspra/'+service_id) 
  }

  saveInspraConfig(data) {

    return this.http.post(this.base_url+'/myalltel/config/inspra/saveConfig',data) 
  }


  updateVirtualReceptionConfig(data){

    return this.http.post(this.base_url+'/myalltel/config/virtualreceptionist', data)
  }

  updateTmcConfig(data){

    return this.http.post(this.base_url+'/myalltel/config/tmc', data)
  }

  getScheduledTmcConfig(service_id) {

    return this.http.get(this.base_url+'/myalltel/config/tmc/scheduled/'+service_id) 
  }

  scheduleTmcConfig(data) {
    return this.http.post(this.base_url+'/myalltel/config/tmc/schedule', data)
  }

  getVirtualReceptionCostSummary(data) {

    return this.http.post(this.base_url+'/myalltel/config/virtualreceptionist/changesummary', data)
  }

  getTmcCostSummary(data) {

    return this.http.post(this.base_url+'/myalltel/config/tmc/changesummary', data)
  }

  getVirtualReceptionLogs(data){
    return this.http.get(this.base_url+`/myalltel/reports/listvirtualreception?page=${data.page}&perpage=${data.perpage}&q=${data.service_id}&includeclosed=${data.includeclosed}`)
  }

  getVirtualReceptionMessage(data, filter){
    return this.http.get(this.base_url+`/myalltel/reports/virtualreception/${data}?page=${filter.page}&perpage=${filter.perpage}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
  }

  getCallLog(data){
    return this.http.get(this.base_url+`/myalltel/reports/listcallrecords?page=${data.page}&perpage=${data.perpage}&q=${data.service_id}`)
  }

  getMobileServices(data){
    return this.http.get(this.base_url+`/myalltel/reports/listmobileservices?page=${data.page}&perpage=${data.perpage}&q=${data.service_id}`)
  }

  getCallSummary(data){
    return this.http.get(this.base_url+`/myalltel/reports/listInboundSummary?page=${data.page}&perpage=${data.perpage}&q=${data.service_id}`)
  }

  getCallRecord(data, filter){
    return this.http.get(this.base_url+`/myalltel/reports/callrecords/${data}?page=${filter.page}&perpage=${filter.perpage}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
  }

  getCallRecordCsv(data, filter){
    return this.http.get(this.base_url+`/myalltel/reports/callrecordsCsv/${data}?start_date=${filter.start_date}&end_date=${filter.end_date}`,{responseType: 'text'})
  }

  getFax2EmailLogs(data){
    return this.http.get(this.base_url+`/myalltel/reports/listfax2email?page=${data.page}&perpage=${data.perpage}&order_by=${data.order_by}&order_type=${data.order_type}&q=${data.service_id}`)
  }

  getVoice2EmailLogs(data){
    return this.http.get(this.base_url+`/myalltel/reports/listvoice2email?page=${data.page}&perpage=${data.perpage}&order_by=${data.order_by}&order_type=${data.order_type}&q=${data.service_id}`)
  }

  getLocalConnectLogs(data){
    return this.http.get(this.base_url+`/myalltel/reports/listlocalconnect?page=${data.page}&perpage=${data.perpage}&order_by=${data.order_by}&order_type=${data.order_type}&q=${data.service_id}`)
  }

  getFax2EmailRecord(data, filter){
    return this.http.get(this.base_url+`/myalltel/reports/fax2email/${data}/records?page=${filter.page}&perpage=${filter.perpage}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
  }

  getVoice2EmailRecord(data, filter){
    return this.http.get(this.base_url+`/myalltel/reports/voice2email/${data}/records?page=${filter.page}&perpage=${filter.perpage}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
  }

  getLocalConnectRecord(data, filter){
    return this.http.get(this.base_url+`/myalltel/reports/localconnect/${data}/records?page=${filter.page}&perpage=${filter.perpage}&start_date=${filter.start_date}&end_date=${filter.end_date}`)
  }

  downloadRecord(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(this.base_url+"/myalltel/voicelogic/record/"+id+"/download", { headers: headers, responseType: 'blob' })
  }

  downloadCallRecording(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(this.base_url+"/myalltel/voicelogic/callrecording/"+id+"/download", { headers: headers, responseType: 'blob' })
  }

  downloadSummary(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(this.base_url+"/myalltel/inboundsummary/"+id+"/download", { headers: headers, responseType: 'blob' })
  }

  getVoiceLogic(service_id) {
    return this.http.get(this.base_url+'/myalltel/config/voicelogic/'+service_id) 
  }

  getCommscode(service_id) {
    return this.http.get(this.base_url+'/myalltel/config/commscode/'+service_id) 
  }

  getCommscodeAudio(service_id) {
    return this.http.get(this.base_url+'/myalltel/config/commscode/audio/'+service_id) 
  }

  getRubixConfig(service_id) {
    return this.http.get(this.base_url+'/myalltel/config/rubix/'+service_id) 
  }

  updateFax2EmailConfig(data) {
    return this.http.post(this.base_url+'/myalltel/config/voicelogic/fax2email',data)
  }

  updateCommscodeVoice2EmailConfig(data) {
    return this.http.post(this.base_url+'/myalltel/config/commscode/voice2email',data)
  }

  updateRubixConfig(data) {
    return this.http.post(this.base_url+'/myalltel/config/rubix',data)
  }

  getVoiceLogicConfiguration(service_id) {
    return this.http.get(this.base_url+'/myalltel/config/voicelogic/'+service_id)
  }

  uploadServiceFile(data) {
    return this.http.post(this.base_url+'/myalltel/services/upload', data)
  }

  uploadCommscodeFile(data) {
    return this.http.post(this.base_url+'/myalltel/config/commscode/upload', data)
  }

  updateVoice2EmailConfig(data) {
    return this.http.post(this.base_url+'/myalltel/config/voicelogic/voice2email', data)
  }

  suspendService(service_id) {
    return this.http.post(this.base_url+'/myalltel/service/suspend', {service_id})
  }

  updateLocalConnectConfig(data) {
    return this.http.post(this.base_url+'/myalltel/config/voicelogic/localconnect ', data)
  }

}